export const LOCATIONVIEW_OPEN = 'LOCATIONVIEW_OPEN';
export const LOCATIONVIEW_CLOSE = 'LOCATIONVIEW_CLOSE';
